/**
 * @author mrdoob / http://mrdoob.com/
 * @author marklundin / http://mark-lundin.com/
 * @author alteredq / http://alteredqualia.com/
 */

import * as THREE from 'three';
import ThreeMapeaImplControl from 'impl/threemapeacontrol';

const AnaglyphEffect = function ( renderer, width, height ) {

	var eyeRight = new THREE.Matrix4();
	var eyeLeft = new THREE.Matrix4();
	var _zeroParallax = 200, _slope = 60;
	var _aspect, _near, _far, _fov;

	var _cameraL = new THREE.PerspectiveCamera();
	_cameraL.matrixAutoUpdate = false;

	var _cameraR = new THREE.PerspectiveCamera();
	_cameraR.matrixAutoUpdate = false;

	var _camera = new THREE.OrthographicCamera( -1, 1, 1, - 1, 0, 1 );

	var _scene = new THREE.Scene();

	var _params = { minFilter: THREE.LinearFilter, magFilter: THREE.NearestFilter, format: THREE.RGBAFormat };

	if ( width === undefined ) width = 512;
	if ( height === undefined ) height = 512;

	var _renderTargetL = new THREE.WebGLRenderTarget( width, height, _params );
	var _renderTargetR = new THREE.WebGLRenderTarget( width, height, _params );
	
	this.getAnaglyphColors = function() {
	
		var anaglyphType = '';
		if(ThreeMapeaImplControl){anaglyphType = document.getElementById("anaglyphType").value}
		//optimiced
		var AnaglyphColor = {
				lr1: "0.0", lg1: "0.7", lb1: "0.3",
				rr2: "0.0", rg2: "1.0", rb2: "0.0",
				rr3: "0.0", rg3: "0.0", rb3: "1.0"
		}
		
		switch (anaglyphType){
			case "normal":
				AnaglyphColor = {
					lr1: "1.0", lg1: "0.0", lb1: "0.0",
					rr2: "0.0", rg2: "1.0", rb2: "0.0",
					rr3: "0.0", rg3: "0.0", rb3: "1.0"
				}
			break;
			case "half":
				AnaglyphColor = {
					lr1: "0.299", lg1: "0.587", lb1: "0.114",
					rr2: "0.0", rg2: "1.0", rb2: "0.0",
					rr3: "0.0", rg3: "0.0", rb3: "1.0"
				}
			break;
			case "gray":
				AnaglyphColor = {
					lr1: "0.299", lg1: "0.587", lb1: "0.114",
					rr2: "0.299", rg2: "0.587", rb2: "0.114",
					rr3: "0.299", rg3: "0.587", rb3: "0.114"
				}
			break;
		}
		
		return(AnaglyphColor);
	}
	
	//var anaglyphColor = this.getAnaglyphColors();
	
	this.getFragmentShader = function() {
		var anaglyphColor = this.getAnaglyphColors();
		var _fragmentShader = [

			"uniform sampler2D mapLeft;",
			"uniform sampler2D mapRight;",
			"varying vec2 vUv;",

			"void main() {",

			"	vec4 colorL, colorR;",
			"	vec2 uv = vUv;",

			"	colorL = texture2D( mapLeft, uv );",
			"	colorR = texture2D( mapRight, uv );",

				// http://3dtv.at/Knowhow/AnaglyphComparison_en.aspx

			"	gl_FragColor = vec4( colorL.r * "+ anaglyphColor.lr1 +" + colorL.g * "+ anaglyphColor.lg1 +" + colorL.b * "+ anaglyphColor.lb1 +", colorR.r * "+ anaglyphColor.rr2 +" + colorR.g * "+ anaglyphColor.rg2 +" + colorR.b * "+ anaglyphColor.rb2 +", colorR.r * "+ anaglyphColor.rr3 +" + colorR.g * "+ anaglyphColor.rg3 +" + colorR.b * "+ anaglyphColor.rb3 +", colorL.a + colorR.a ) * 1.1;",

			"}"

		].join("\n");
		
		if( ThreeMapeaImplControl && ThreeMapeaImplControl.anaglyphType == "interlaced" ) {
		
			_fragmentShader = [

				"uniform sampler2D mapLeft;",
				"uniform sampler2D mapRight;",
				"varying vec2 vUv;",

				"void main() {",


				"	vec2 uv = vUv;",

				"	if ( ( mod( gl_FragCoord.y, 2.0 ) ) < 1.00 ) {",

				"		gl_FragColor = texture2D( mapRight, uv );",

				"	} else {",



				"		gl_FragColor = texture2D( mapLeft, uv );",


				"	}",


				"}"

			].join("\n")
		
		} else if( ThreeMapeaImplControl && ThreeMapeaImplControl.anaglyphType == "interlaced swap" ){
		
			_fragmentShader = [

				"uniform sampler2D mapLeft;",
				"uniform sampler2D mapRight;",
				"varying vec2 vUv;",

				"void main() {",


				"	vec2 uv = vUv;",

				"	if ( ( mod( gl_FragCoord.y, 2.0 ) ) < 1.00 ) {",

				"		gl_FragColor = texture2D( mapLeft, uv );",

				"	} else {",



				"		gl_FragColor = texture2D( mapRight, uv );",


				"	}",


				"}"

			].join("\n")
		
		}
		
		return _fragmentShader;
	}
	
	var _material = new THREE.ShaderMaterial( {

		uniforms: {

			"mapLeft": { type: "t", value: _renderTargetL },
			"mapRight": { type: "t", value: _renderTargetR }

		},

		vertexShader: [

			"varying vec2 vUv;",

			"void main() {",

			"	vUv = vec2( uv.x, uv.y );",
			"	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );",

			"}"

		].join("\n"),

		fragmentShader: this.getFragmentShader()/*[

			"uniform sampler2D mapLeft;",
			"uniform sampler2D mapRight;",
			"varying vec2 vUv;",

			"void main() {",

			"	vec4 colorL, colorR;",
			"	vec2 uv = vUv;",

			"	colorL = texture2D( mapLeft, uv );",
			"	colorR = texture2D( mapRight, uv );",

				// http://3dtv.at/Knowhow/AnaglyphComparison_en.aspx

			"	gl_FragColor = vec4( colorL.r * "+ anaglyphColor.lr1 +" + colorL.g * "+ anaglyphColor.lg1 +" + colorL.b * "+ anaglyphColor.lb1 +", colorR.r * "+ anaglyphColor.rr2 +" + colorR.g * "+ anaglyphColor.rg2 +" + colorR.b * "+ anaglyphColor.rb2 +", colorR.r * "+ anaglyphColor.rr3 +" + colorR.g * "+ anaglyphColor.rg3 +" + colorR.b * "+ anaglyphColor.rb3 +", colorL.a + colorR.a ) * 1.1;",

			"}"

		].join("\n")*/
	} );

	var mesh = new THREE.Mesh( new THREE.PlaneGeometry( 2, 2 ), _material );
	_scene.add( mesh );

	this.setSize = function ( width, height ) {

		if ( _renderTargetL ) _renderTargetL.dispose();
		if ( _renderTargetR ) _renderTargetR.dispose();
		_renderTargetL = new THREE.WebGLRenderTarget( width, height, _params );
		_renderTargetR = new THREE.WebGLRenderTarget( width, height, _params );

		_material.uniforms[ "mapLeft" ].value = _renderTargetL;
		_material.uniforms[ "mapRight" ].value = _renderTargetR;

		renderer.setSize( width, height );

	};

	/*
	 * Renderer now uses an asymmetric perspective projection
	 * (http://paulbourke.net/miscellaneous/stereographics/stereorender/).
	 *
	 * Each camera is offset by the eye seperation and its projection matrix is
	 * also skewed asymetrically back to converge on the same projection plane.
	 * Added a focal length parameter to, this is where the parallax is equal to 0.
	 */

	this.render = function ( scene, camera, zeroParallax, slope ) {

		scene.updateMatrixWorld();

		if ( camera.parent === undefined ) camera.updateMatrixWorld();
		if ( slope === undefined ) slope = _slope;

		var hasCameraChanged = ( _aspect !== camera.aspect ) || ( _near !== camera.near ) || ( _far !== camera.far ) || ( _fov !== camera.fov ) ||
                               ( _zeroParallax !== zeroParallax ) || (_slope != slope );

		if ( hasCameraChanged ) {

			_aspect = camera.aspect;
			_near = camera.near;
			_far = camera.far;
			_fov = camera.fov;
			_zeroParallax = zeroParallax;
			_slope = slope;

			var projectionMatrix = camera.projectionMatrix.clone();
//			var eyeSep = _zeroParallax / 30 * 0.5;
			var eyeSep = _zeroParallax * THREE.Math.degToRad( _fov * 0.5 ) * 2 * slope / 100.; 
			var eyeSepOnProjection = eyeSep * _near / _zeroParallax;
			var ymax = _near * Math.tan( THREE.Math.degToRad( _fov * 0.5 ) );
			var xmin, xmax;

			// translate xOffset

			eyeRight.elements[12] = eyeSep;
			eyeLeft.elements[12] = -eyeSep;

			// for left eye

			xmin = -ymax * _aspect + eyeSepOnProjection;
			xmax = ymax * _aspect + eyeSepOnProjection;

			projectionMatrix.elements[0] = 2 * _near / ( xmax - xmin );
			projectionMatrix.elements[8] = ( xmax + xmin ) / ( xmax - xmin );

			_cameraL.projectionMatrix.copy( projectionMatrix );

			// for right eye

			xmin = -ymax * _aspect - eyeSepOnProjection;
			xmax = ymax * _aspect - eyeSepOnProjection;

			projectionMatrix.elements[0] = 2 * _near / ( xmax - xmin );
			projectionMatrix.elements[8] = ( xmax + xmin ) / ( xmax - xmin );

			_cameraR.projectionMatrix.copy( projectionMatrix );
			
		}
		
		_cameraL.matrixWorld.copy( camera.matrixWorld ).multiply( eyeLeft );
		_cameraL.position.copy( camera.position );
		_cameraL.near = camera.near;
		_cameraL.far = camera.far;

		renderer.render( scene, _cameraL, _renderTargetL, true );

		_cameraR.matrixWorld.copy( camera.matrixWorld ).multiply( eyeRight );
		_cameraR.position.copy( camera.position );
		_cameraR.near = camera.near;
		_cameraR.far = camera.far;

		renderer.render( scene, _cameraR, _renderTargetR, true );

		renderer.render( _scene, _camera );

	};

	this.dispose = function() {
	
		if ( _renderTargetL ) _renderTargetL.dispose();
		if ( _renderTargetR ) _renderTargetR.dispose();
		
	};

	// Modifica los par�metros del modelo estereosc�pico
	// fov0: Angular de la c�mara inicialmente
	// Z0: Cota de la c�mara inicialmente.
	// H0: Distancia a paralaje nulo inicialmente.
	// H: Distancia a paralaje nulo nueva.
	// pcZeroParallax: Variaci�n en % del paralaje nulo: -50%: 0.5*H0   0%: 1.0*H0    50%: 1.5*H0
	// pcMagnification: Variaci�n de la magnificaci�n var�a la Z y el angular haciendo que abarque el mismo �mbito del terreno:
    //  	-50%: Z = z0 + H0/2.    0%:  Z = Z0      50%:  Z = Z0 - H0/2. fov se var�a obligando a que abarque el mismo terreno 
	this.updateStereoParams = function( scene, camera, fov0, Z0, H0, pcZeroParallax, pcMagnification) {
		// Nueva distancia de paralaje nulo
		var H = H0 * (1 + pcZeroParallax / 500.);
		// Nueva cota de la c�mara angular de la c�mara
		// Toma nuevos valores para ajustarlos a la exageraci�n
		//var incZ = -(H * pcMagnification / 100.);
		//var tan_alf = Math.tan( THREE.Math.degToRad( fov0 * 0.5 ) );
		//var tan_alfn = H * tan_alf / (H+incZ);
		//var alfn = Math.atan( tan_alfn );
		//camera.fov = 2 * THREE.Math.radToDeg( alfn );
		var mag;
		if ( fov0 == 70 ) {
			if ( pcMagnification >= 0 ) mag = pcMagnification/1.25;
			else mag = pcMagnification/2.25;
		} else if ( fov0 == 30 ) {
			if ( pcMagnification >= 0 ) mag = pcMagnification/2.5;
			else mag = pcMagnification/3.5;
		} else {
			var pos = (130-fov0)/90;
			var neg = (fov0-20)/90;
			if ( pcMagnification >= 0 ) mag = pcMagnification*pos;
			else mag = pcMagnification*neg;
		}
		//var _fov = THREE.Math.degToRad( fov0 + pcMagnification/1.5) > 0 ? THREE.Math.degToRad( fov0 + pcMagnification/1.5) : 0.01;
		camera.fov = THREE.Math.radToDeg( THREE.Math.degToRad( fov0 + mag)  );
		var tan_alf = Math.tan( THREE.Math.degToRad( fov0 / 2 ) );
		var tan_alf2 = Math.tan( THREE.Math.degToRad( fov0 + mag) / 2 );
		var incZ = H*(tan_alf/tan_alf2-1);
		camera.position.z = Z0 + incZ;
		H += incZ;
		camera.updateMatrixWorld();	
		camera.updateProjectionMatrix();	
		this.render( scene, camera, H );
		camera.fov = fov0;
		camera.position.z = Z0;
		camera.updateMatrixWorld();	
		camera.updateProjectionMatrix();
	}
/*	this.updateStereoParams = function( scene, camera, fov0, Z0, H0, pcZeroParallax, pcMagnification) {
		// Nueva distancia de paralaje nulo
		var H = H0 * (1 + pcZeroParallax / 200.);
		// Nueva cota de la c�mara angular de la c�mara
		var Z = Z0, fov = fov0;
		// Toma nuevos valores para ajustarlos a la exageraci�n
		var incZ = -(H * pcMagnification / 100.);
		var tan_alf = Math.tan( THREE.Math.degToRad( fov0 * 0.5 ) );
		var tan_alfn = H * tan_alf / (H+incZ);
		var alfn = Math.atan( tan_alfn );
		camera.fov = 2 * THREE.Math.radToDeg( alfn );
		camera.position.z = Z0 + incZ;
		H += incZ;
		camera.updateMatrixWorld();	
		camera.updateProjectionMatrix();	
		this.render( scene, camera, H );
		camera.fov = fov0;
		camera.position.z = Z0;
		camera.updateMatrixWorld();	
		camera.updateProjectionMatrix();
	}
*/	

	// Modifica la posici�n de paralaje 0. pC es el % que aumenta (+) o disminuye (-) la distancia de paralaje 0
	this.updateZeroParallax = function( scene, camera, H0, pC ) {
		this.render( scene, camera, H0*(1+pC/100.) );
	}

	// Modifica el angular de la c�mara y altura de la c�mara manteniendo igual el mismo campo de visi�n y la distancia de paralaje cero
	this.updateMagnification = function( scene, camera, fov, Z0, H0, pC) {
		var incZ = -(H0 * pC / 100.);
		var tan_alf = Math.tan( THREE.Math.degToRad( fov * 0.5 ) );
		var tan_alfn = H0 * tan_alf / (H0+incZ);
		var alfn = Math.atan( tan_alfn );
		camera.fov = 2 * THREE.Math.radToDeg( alfn );
		camera.position.z = Z0 + incZ;
		camera.updateProjectionMatrix();	
		this.render( scene, camera, H0+incZ );
	}
	
	//Modifica los colores del Anaglifo
	this.updateAnaglyphType = function( scene, camera ) {
		

		_material.fragmentShader = this.getFragmentShader();/*[
			"uniform sampler2D mapLeft;",
			"uniform sampler2D mapRight;",
			"varying vec2 vUv;",
			
			"void main() {",

			"	vec4 colorL, colorR;",
			"	vec2 uv = vUv;",
			"	colorL = texture2D( mapLeft, uv );",
			"	colorR = texture2D( mapRight, uv );",
	
			"	gl_FragColor = vec4( colorL.r * "+ anaglyphColor.lr1 +" + colorL.g * "+ anaglyphColor.lg1 +" + colorL.b * "+ anaglyphColor.lb1 +", colorR.r * "+ anaglyphColor.rr2 +" + colorR.g * "+ anaglyphColor.rg2 +" + colorR.b * "+ anaglyphColor.rb2 +", colorR.r * "+ anaglyphColor.rr3 +" + colorR.g * "+ anaglyphColor.rg3 +" + colorR.b * "+ anaglyphColor.rb3 +", colorL.a + colorR.a ) * 1.1;",
									
			"}"
		].join("\n")*/	
			
		_material.needsUpdate = true;
		
		ThreeMapeaImplControl.anaglyphRenderer.updateStereoParams( ThreeMapeaImplControl.scene, ThreeMapeaImplControl.camera, ThreeMapeaImplControl.fov, ThreeMapeaImplControl.z0camera, ThreeMapeaImplControl.zeroParallax, ThreeMapeaImplControl.valuesSet.comparationPlane, ThreeMapeaImplControl.valuesSet.magnification );
	
	};
	
};

export {AnaglyphEffect};